import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=536d71bd&scoped=true&"
import script from "./stepper.vue?vue&type=script&lang=js&"
export * from "./stepper.vue?vue&type=script&lang=js&"
import style0 from "./stepper.vue?vue&type=style&index=0&id=536d71bd&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d71bd",
  null
  
)

export default component.exports